module.exports = __webpack_public_path__ + "img/stock-photo-3.1709a1bf.jpg";